import type { CrremYearlyPoint } from "../model/types";

export const collectPathwayYears = (...series: CrremYearlyPoint[][]) =>
  [...new Set(series.flat().map((point) => point.year))].sort((left, right) => left - right);

export const collectChartYears = (pointSeries: CrremYearlyPoint[][], extraYears: number[]) =>
  [...new Set([...pointSeries.flat().map((point) => point.year), ...extraYears])].sort((left, right) => left - right);

export const valueAtYear = (points: CrremYearlyPoint[], year: number) =>
  points.find((point) => point.year === year)?.value ?? null;
